export var WEBSITE_URL;

if (window.location.hostname === 'localhost') {
  WEBSITE_URL = 'http://localhost:3000';
}
else {
  WEBSITE_URL = 'https://lollet.kerkarcreations.com';
}

// Nepal timezone constant
export const NEPAL_TIMEZONE = 'Asia/Kathmandu';